import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"

import {
  IBolTableVisibility,
  IContractTableVisibility,
  IFinancialReportVisibility,
  ILoadingFreightBolBrokerRecordsVisibility,
} from "~/store/behavior-table/types"
import type { RootState } from "~/store/store"

// Define the type mapping for each table key
export type TTableBehavior = {
  "bol-table": IBolTableVisibility
  "contract-table": IContractTableVisibility
  "financial-report-cargo": IFinancialReportVisibility
  "financial-report-bol": IFinancialReportVisibility
  "loading-freight-bol-broker-records-table": ILoadingFreightBolBrokerRecordsVisibility
}

// Define the initial behavior state type
export interface IInitialBehaviorTableState {
  columnsVisibility: {
    [key in keyof TTableBehavior]: TTableBehavior[key]
  }
}

export const initialBehaviorTable: IInitialBehaviorTableState = {
  columnsVisibility: {
    "bol-table": {
      createdAt: true,
      number: true,
      cargoOwner: true,
      goodsType: true,
      senderInfo: true,
      receiverInfo: true,
      state: true,
      systemTrackingNumber: true,
      miniCard: false,
    },
    "contract-table": {
      number: true,
      bolIssuer: true,
      startDate: true,
      endDate: true,
      status: true,
      commissionPercentage: true,
      // createdAt: true,
      // number: true,
      // cargoOwner: true,
      // goodsType: true,
      // senderInfo: true,
      // receiverInfo: true,
      // state: true,
      // miniCard: false,
    },
    "financial-report-cargo": {
      number: true,
      cargoOwnerName: true,
      contractTermType: true,
      goodType: true,
      sourceArea: true,
      destinationArea: true,
      driverName: true,
      submitDateTime: true,
      price: false,
      shipmentPrice: false,
      downPaymentAmount: false,
      commission: false,
      commissionPercent: false,
      issuerCommissionPercent: false,
      netCommissionPercent: false,
      netCommission: false,
    },
    "financial-report-bol": {
      bolNumber: true,
      cargoOwnerName: true,
      contractTermType: true,
      goodType: true,
      sourceArea: true,
      destinationArea: true,
      driverName: true,
      submitDateTime: true,
      price: false,
      commission: false,
      commissionPercent: false,
      issuerCommissionPercent: false,
      netCommissionPercent: false,
      netCommission: false,
    },
    "loading-freight-bol-broker-records-table": {
      bolDateTime: true,
      bolNumber: true,
      bolSerial: true,
      goodType: true,
      tonnage: true,
      wrappingType: true,
      cargoValue: true,
      trackingCode: true,
      sourceProvinceName: true,
      sourceAreaName: true,
      senderNationalId: true,
      senderName: true,
      senderPostalCode: true,
      senderAddress: true,
      destinationProvinceName: true,
      destinationAreaName: true,
      receiverNationalId: true,
      receiverName: true,
      receiverPostalCode: true,
      receiverAddress: true,
      driverNationalId: true,
      driverName: true,
      driverPhoneNumber: true,
      secondDriverNationalId: true,
      secondDriverName: true,
      vehicleDigitalNumber: true,
      vehiclePlateNumber: true,
      trailerTypeName: true,
      insurancePrice: true,
      price: true,
      totalPrice: true,
      commission: true,
      receivedAmountFromDriver: true,
      priceMovingAverage: true,
      totalPriceMovingAverage: true,
      companyCode: true,
      companyName: true,
      ownerName: true,
      destinationAreaCode: true,
      sourceAreaCode: true,
      supplementaryInsurancePrice: true,
      terminalPrice: true,
    },
  },
}

export const BehaviorTableSlice = createSlice({
  name: "behavior-table",
  initialState: initialBehaviorTable,
  reducers: {
    setColumnsVisibility<K extends keyof TTableBehavior>(
      state: IInitialBehaviorTableState,
      action: PayloadAction<{ key: K; data: TTableBehavior[K] }>,
    ) {
      // const isExist = state.columnsVisibility.findIndex(
      //   (item) => item.id === action.payload.id,
      // );
      // if (isExist !== -1) {
      //   state.columnsVisibility[isExist] = {
      //     ...state.columnsVisibility[isExist],
      //     ...action.payload,
      //   };
      // } else {
      //   state.columnsVisibility.push(action.payload);
      // }
      state.columnsVisibility[action.payload.key] = {
        ...state.columnsVisibility[action.payload.key],
        ...action.payload.data,
      }
    },
  },
})

export const { setColumnsVisibility } = BehaviorTableSlice.actions
export const useBehaviorTable = () =>
  useSelector((state: RootState) => state.behaviorTable)
export default BehaviorTableSlice.reducer
